import { useContext, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api from "../../../Components/Api/Api";
import Spinner from "../../../Components/Spinner";
import { UserContext } from '../../../context/UserContext';

const OrdemInfo = () => {
    const navigate = useNavigate(); 
    const location = useLocation();
    const {user} = useContext(UserContext)
    const orcamento = location.state;
    const [ShowLoading, setShowLoading] = useState(false) 
    const [orcamentos, setOrcamentos] = useState([])
    const [atualizar, setAtualizar] = useState(false) 
    const credentials = btoa(`${user.userRest}:${user.passRest}`); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "User-Agent": "PneusBrasil",
        "Accept": "application/json",
        'Authorization': `Basic ${credentials}`
    }     
    function getos () {
        setTimeout(() => {
        setShowLoading(true)
        api.get('Ordemservico?filial='+user.filial+'&Orcamento='+orcamento,{headers})
        .then(response => {
              //console.log(response.data.Entradas)
              if (response.data.Ordens.length > 0 ){   
                  //console.log(response.data.Entradas[0]['Num'])  
                  setOrcamentos(response.data.Ordens)
                  setAtualizar(true) 
                  setShowLoading(false)  
                  //console.log(orcamentos)
                  //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
              }else{
                  //setInfoveuculo('Placa não cadastrada!')
                  setShowLoading(false)
                  setAtualizar(true)
              }                                   
        });
      }, 10 );        
    }; 
    useEffect(() => {
        if(!atualizar){
            getos()
        }                
    })       
    return(
        <>
        <Container>
            <div>
                <span className="mt-4 d-flex justify-content-center fs-3 text-primary">Ordem de serviço - {orcamento}</span>
            </div> 
            <div>
                {orcamentos.map((list: any) => ( 
                    <div key={list.id}>
                        <p className="row">Cliente: {list.nomecliente}</p>
                        <p className="row">Veiculo: Marca - {list.marca} Modelo - {list.modelo} Cor - {list.cor} Placa - {list.placa}</p>
                        <p className="row">Mecanico: {list.mecanico}</p>
                        <p className="row">Status: {list.status}</p>

                    </div>
                ))}
            </div>
            <div className="mt-4">
                <button><Link to='/Oficina'>Voltar</Link></button>
            </div>                       
        </Container>
        <Spinner isLoading={ShowLoading} /> 
        </>
    )
}

export default OrdemInfo;